<template>
  <main class="l-main p-login">
    <div class="p-login__main">
      <div class="header">
        <div class="header-login">
          <p class="header-login__logo">
            <a :href="$constants.serviceSiteUrl">
              <img
                src="@/assets/img/logo.svg"
                :alt="$constants.siteName"
                class="c-title__register-image"
              />
            </a>
          </p>
        </div>
      </div>
      <div class="flex">
        <div class="c-center__box">
          <h2 class="c-center__box-logo">
            <img src="@/assets/img/txt-login.svg" alt="Login" />
          </h2>
          <div class="inBlock">
            <div class="c-alertPos">
              <Input
                name="email"
                placeholder="ログインID（メールアドレス）"
                v-focus
                v-model="params.email"
                :disabled="isMaintenance"
                @enter="login"
                :class="{ alert: isEdited.email && error.email }"
              />
              <span></span>
              <Alert v-if="isEdited.email && error.email">
                {{ error.email }}
              </Alert>
            </div>
            <div class="c-alertPos">
              <InputPassword
                name="password"
                placeholder="パスワード"
                v-model="params.password"
                :disabled="isMaintenance"
                @enter="login"
                :class="{ alert: isEdited.password && error.password }"
              />
              <Alert v-if="isEdited.password && error.password">
                {{ error.password }}
              </Alert>
            </div>
            <Button
              variant="main"
              size="w280"
              icon="arrow_r"
              :class="{ 'is-loading': isProcessing }"
              :disabled="isError || isProcessing || isMaintenance"
              @click="login"
            >
              ログイン
            </Button>
            <p v-if="!$constants.isDemo && !isMaintenance" class="addForget">
              <router-link :to="{ name: 'resetPassword' }">
                パスワードを忘れた方
              </router-link>
            </p>
            <Alert v-if="errorAll">
              <div class="errorAll">
                {{ errorAll }}
              </div>
            </Alert>
          </div>
        </div>
      </div>
      <Footer />
    </div>
    <!-- <div class="p-login__sub">
      <div class="flex">
        <div class="c-center__box">
          <h2 class="c-center__box-contact">
            <img src="@/assets/img/txt-information.svg" alt="Information" />
          </h2>
          <ListNews />
          <a
            :href="$constants.serviceSiteUrl + '/inquiry/'"
            class="grd c-btn c-btn--w280 c-btn--contact c-btn--arrow_r"
            target="_blank"
          >
            <span>ご相談・お問い合わせ</span>
          </a>
        </div>
      </div>
    </div> -->
    <ModalMaintenance v-if="isMaintenance" />
  </main>
</template>

<script>
import { ERROR_MESSAGE } from '@/constants';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Footer from '@/components/layouts/Footer';
import Input from '@/components/Input';
import InputPassword from '@/components/InputPassword';
// import ListNews from '@/components/login/ListNews';
import ModalMaintenance from '@/components/notifications/ModalMaintenance';
import utils from '@/utils';
import Validation from '@/validation';

export default {
  components: {
    Alert,
    Button,
    Footer,
    Input,
    InputPassword,
    // ListNews,
    ModalMaintenance
  },

  data() {
    return {
      error: {
        email: '',
        password: ''
      },
      errorAll: '',
      params: {
        email: '',
        password: ''
      },
      isEdited: {
        email: false,
        password: false
      },
      isError: false,
      isProcessing: false
    };
  },

  computed: {
    isMaintenance() {
      return this.$store.getters['view/isMaintenance'];
    }
  },

  watch: {
    error: {
      handler() {
        this.checkError();
      },
      deep: true
    },
    'params.email': {
      handler(value, oldValue) {
        this.error.email = new Validation()
          .input()
          .email()
          .test(this.params.email.trim());
        if (typeof oldValue !== 'undefined') {
          this.isEdited.email = true;
        }
      },
      immediate: true
    },
    'params.password': {
      handler(value, oldValue) {
        this.error.password = new Validation()
          .input()
          .test(this.params.password);
        if (typeof oldValue !== 'undefined') {
          this.isEdited.password = true;
        }
      },
      immediate: true
    }
  },

  methods: {
    checkError() {
      this.isError = utils.checkError(this.error);
    },
    login() {
      if (this.isError || this.isProcessing || this.isMaintenance) {
        return;
      }

      this.isProcessing = true;

      this.auth.login(this.params).catch(error => {
        this.isProcessing = false;
        this.errorAll = ERROR_MESSAGE.auth0[error.code]
          ? ERROR_MESSAGE.auth0[error.code]
          : ERROR_MESSAGE.other;
      });
    }
  }
};
</script>
